module.exports = __webpack_public_path__ + "static/img/sport_ou_logo.738c823.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/program_logo/sport_ou_logo.png
// module id = a8o5
// module chunks = 0